import { createTokenInput } from '@/js/utils/createTokenInput';
import {
  getRecaptchaErrorMessage,
  getRecaptchaToken,
  isRecaptchaErrorCode,
} from '@/js/utils/getRecaptchaToken';
import { showToast } from '@/js/utils/show-toast';

export const beforeSubmit = async (form: HTMLFormElement) => {
  try {
    const token = await getRecaptchaToken();

    const tokenInput = form.querySelector<HTMLInputElement>('#ctoken') ?? createTokenInput(form);

    tokenInput.value = token;

    return true;
  } catch (error: unknown) {
    if (isRecaptchaErrorCode(error)) {
      showToast(getRecaptchaErrorMessage(error), 'failed');
      return false;
    }

    showToast('Ошибка соединения. Попробуйте еще раз.', 'failed');
    return false;
  }
};
